import React from 'react'

const Reality = () => {
    return (
        <div>
            <span className='pageTitle'>Reality</span>
            <h3>Watch out how hard it is to make movies in AR</h3>
            <h4>To watch the video in AR, Click on the button below to watch the video, which explains you how to open it</h4>
            <img 
            className="img-responsive" 
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSNaxBpaqyT7aWo9t-4jFghSkFFmFpc2dA0tjmozAJuwcpsvCtjo0aCB4I4E20JQksSWLg&usqp=CAU" ></img>
            <button
    type="button"
    onClick={(videos) => {
      videos.preventDefault();
      window.location.href='';
      }}
> Click here</button>
        </div>
    )
}

export default Reality
